import { RedirectParams } from '../../../../../shared/types/redirectParams';

export const initialValues: RedirectParams = {
    name: '',
    extra: '',
    parent: '',
    active: true,
};
